import { render, staticRenderFns } from "./EditMyExercises.vue?vue&type=template&id=b2351cf0&scoped=true"
import script from "./EditMyExercises.vue?vue&type=script&lang=js"
export * from "./EditMyExercises.vue?vue&type=script&lang=js"
import style0 from "./EditMyExercises.vue?vue&type=style&index=0&id=b2351cf0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2351cf0",
  null
  
)

export default component.exports